<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-money-bill"></i> <ng-container i18n>Add Booking Fees</ng-container></h5>
  <button (click)="onClose()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>

<app-booking-fees [rental]="data.rental" (close)="onClose()"></app-booking-fees>
